module.exports = __webpack_public_path__ + "static/img/logo.90bc1cf6.png";